export default "__VITE_ASSET__B793S82P__"